import React, {useState} from "react";
import {MdEmail, MdFileDownload, MdSearch} from "react-icons/md";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import {ROLES} from "../../api/Constants";
import Button from "@material-ui/core/Button";
import {StatementActionButtonRow} from "./StatementScreenStyles"

export default ({
    initialData,
    setData,
    user,
    isSending,
}) => {

    function filterList(event) {
        let items = initialData;
        items = items.filter((item) => {
            return (
                JSON.stringify(item)
                    .toLowerCase()
                    .search(event.target.value.toLowerCase()) !== -1
            );
        });
        setData(items);
    }

    return (
        <>
            {user.role.id <= ROLES.ADMIN &&

                <StatementActionButtonRow>
                    <Button
                        color="primary"
                        variant="contained"
                        startIcon={<MdFileDownload/>}
                        disabled={isSending === true}
                    >
                        All
                    </Button>

                    <Button
                        color="primary"
                        variant="contained"
                        startIcon={<MdEmail/>}
                        disabled={isSending === true}
                    >
                        All
                    </Button>
                </StatementActionButtonRow>
            }
            <br/><br/>
            <TextField
                id="input-with-icon-textfield"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <MdSearch size={20} color="var(--menu-text)"/>
                        </InputAdornment>
                    )
                }}
                onChange={(e) => filterList(e)}
            />
            <br/>
        </>
    );
}